const generateOptions = (
    from: number,
    limitByTime?: Date,
    dayOfWeek?: string
): { id: string; label: string; value: string }[] => {
    const results: { id: string; label: string; value: string }[] = []
    const now = limitByTime
    const currentHour = now?.getHours()
    const currentMinute = now?.getMinutes()

    for (let hour = from; hour <= 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
            if (hour === 24 && minute > 0) break

            if (limitByTime && (hour > currentHour! || (hour === currentHour && minute > currentMinute!))) {
                return results
            }

            const h = hour === 24 ? '24' : hour.toString().padStart(2, '0')
            const m = minute.toString().padStart(2, '0')
            const label = dayOfWeek ? `${h}:${m} (${dayOfWeek})` : `${h}:${m}`
            results.push({ id: crypto.randomUUID(), label, value: label })
        }
    }

    return results
}

// if it's night shift next day, and we have picked the previous day, we want
// 00:00-23:45 of previous day + 00:00-current time of current day

// if it's night shift next day, and we have picked a day before previous day, we want
// 00:00-23:45 of that day

// if it's not night shift next day, and we have picked today, we want
// 00:00-current time of today

// if it's not night shift next day, and we have picked a day before today, we want
// 00:00-23:45 of that day

export const generateTimeOptions = (includePreviousDay: boolean, limitToTime?: Date) => {
    const today = includePreviousDay
        ? new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(new Date())
        : undefined
    const yesterday = includePreviousDay
        ? new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(
              new Date(new Date().setDate(new Date().getDate() - 1))
          )
        : undefined
    const options: { id: string; label: string; value: string }[] = []
    options.push(...generateOptions(0, limitToTime, today))
    if (includePreviousDay) {
        options.unshift(...generateOptions(0, undefined, yesterday).filter((item) => !item.value.startsWith('24:00')))
    }
    return options
}
